import React from "react";
import Banner from "./components/Banner";
import Aboutus from "./components/Aboutus";
import Services from "./components/ServicesDetails";

export default function Home() {
  return (
    <>
      {/* Page Content */}
      <Banner />

      <main>
        <Aboutus />
        <Services />
      </main>
    </>
  );
}
